import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export interface IStaffSelectParams {
  businessId: string
  query?: string | null
  limit?: number
}

export interface IStaffSelectRow {
  id        : string
  lastName  : string | null
  firstName : string | null
  avatar    : string | null
}

export const select = async (
  params: IStaffSelectParams,
): Promise<IStaffSelectRow[]> => {
  return httpRequest.get("/ord/staff/select", params as never)
}
